import React, { useState } from 'react';
import { Form, Input, Radio, Checkbox, Button, DatePicker, Row, Col } from 'antd';

const NuevaSolicitud = () => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
  // ...
    // Aquí puedes enviar los datos del formulario a tu backend
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ textAlign: 'center' }}>SOLICITUD DE SERVICIO Y VERIFICACIÓN DE CAPACIDAD DE RECURSOS</h2>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="FECHA:" name="fecha">
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Cotización:" name="cotizacion">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <h3>DATOS DEL CLIENTE</h3>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="PERSONA QUE SOLICITA:" name="personaSolicita">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="RAZÓN SOCIAL:" name="razonSocial">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="ATENCIÓN A:" name="atencionA">
          <Input />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="TELÉFONO FAX:" name="telefonoFax">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="CEL.:" name="celular">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="E-MAIL:" name="email">
          <Input type="email" />
        </Form.Item>

        <Form.Item label="DOMICILIO FISCAL:" name="domicilioFiscal">
          <Input.TextArea rows={4} />
        </Form.Item>

        <h3>TIPO DE SERVICIO</h3>

        <Form.Item name="tipoServicio" label="Tipo de Servicio">
          <Radio.Group>
            <Radio value="CONCRETO">CONCRETO</Radio>
            <Radio value="TERRACERIAS">TERRACERIAS</Radio>
            <Radio value="MECÁNICA DE SUELOS">MECÁNICA DE SUELOS</Radio>
            <Radio value="OTRO">OTRO</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item label="ESPECIFIQUE:" name="especifique">
          <Input />
        </Form.Item>

        <h3>DATOS DEL PROYECTO</h3>

        <Form.Item label="DIRECCIÓN DE LA OBRA:" name="direccionObra">
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item label="DURACIÓN DEL SERVICIO (APROXIMADO):" name="duracionServicio">
          <Input />
        </Form.Item>

        <Form.Item label="COMENTARIOS ADICIONALES:" name="comentariosAdicionales">
          <Input.TextArea rows={4} />
        </Form.Item>

        <h3>REVISIÓN DE RECURSOS (SI=√ NO=x)</h3>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="ECONÓMICOS" name="recursosEconomicos" valuePropName="checked">
              <Checkbox />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="PERSONAL" name="recursosPersonal" valuePropName="checked">
              <Checkbox />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="DESCRIPCIÓN" name="recursosDescripcion">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="EQUIPO" name="recursosEquipo" valuePropName="checked">
              <Checkbox />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="PROCEDIMIENTO" name="recursosProcedimiento" valuePropName="checked">
              <Checkbox />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="INSTALACIONES" name="recursosInstalaciones" valuePropName="checked">
              <Checkbox />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="TIEMPO (PERIODO)" name="recursosTiempo" valuePropName="checked">
              <Checkbox />
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item label="OTROS" name="recursosOtros">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="TIEMPO DE ENTREGA DE RESULTADOS:" name="tiempoEntregaResultados">
          <Input />
        </Form.Item>

        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'center' }}>
            <label>RECIBE SOLICITUD</label>
          </Col>
          <Col span={8} style={{ textAlign: 'center' }}>
            <label>ELABORA COTIZACIÓN</label>
          </Col>
          <Col span={8} style={{ textAlign: 'center' }}>
            <label>REVISA</label>
          </Col>
        </Row>

        <Form.Item style={{ textAlign: 'center' }}>
          <Button type="primary" htmlType="submit">
            Enviar
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default NuevaSolicitud;